import { ICollector } from './SpinOutcome';

export enum EBullshitCollectorSimulationType {
    SPINS = 'SPINS',
    SYMBOLS = 'SYMBOLS'
}

export interface IBullshitCollectorConfig {
    id: number;
    spine: string;
    simulation: {
        total: number;
        countPerLevel: number[];
        countDeviation: number;
        basedOn: EBullshitCollectorSimulationType;
        symbolIds?: number[];
        resetOnEvents: string[];
    };
}

export interface IBullshitCollector extends ICollector {
    currentLevel: number;
    currentLevelDeviation: number;
}

export interface ICollectorStore {
    collectorsToChangeLevel: (number | undefined)[];
    activeCollectors: ICollector[];
    activeBullshitCollectors: IBullshitCollector[];
}
export interface IDefaultCollector {
    perBet?: boolean;
    start: number;
    total: number;
    symbolIds?: number[];
    reelIndex?: number;
}
